module.exports = __webpack_public_path__ + "fonts/HSESans-Black.64be0eb.otf";